import React, { useRef, useState } from "react";
import { Skeleton, Empty } from "antd";
import ReactEcharts from "echarts-for-react";
import PropTypes from "prop-types";
import Card from "./MocoCard";
import Table from "./MocoTable";

const ChartCard = (props) => {
  const [tableShown, setTableShown] = useState(false);
  const [table, setTable] = useState({});

  const { options } = props;

  // Declare ref for Echarts Component
  let componentRef = useRef();

  const defaultFunctions = {
    saveAsImage: () => {
      // This function implement Echart functionality to get base64 form.
      // Then base64 passed into new tab that filled iframe for showing the charts
      // Chart is connected based from ref
      const echartInstance = componentRef.getEchartsInstance();
      const base64 = echartInstance.getDataURL({
        type: "png",
        backgroundColor: "#fff",
      });
      const win = window.open();
      win.document.write(
        `<iframe src="${base64}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
      );
    },
    getTable: () => {
      // This function set state tableShown for showing table
      // Also set state for table columns and table dataSource
      setTableShown(!tableShown);
      setTable({ columns: options.columns, dataSource: options.dataSource });
    },
  };

  // Destructuring props and give default value
  const { content, functions = defaultFunctions, state } = props;

  const renderContent = () => {
    if (state.data.length === 0) {
      return (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span style={{ fontWeight: "bold" }}>Tidak ada data</span>
          }
        />
      );
    }
    return tableShown ? (
      // If tableShow is true, render Table
      <Table {...table} />
    ) : (
      // If tableShow is false, render Echarts
      <ReactEcharts
        option={options.chartOption}
        ref={(e) => {
          componentRef = e;
        }}
      />
    );
  };

  return (
    <Card
      {...content}
      functions={functions}
      options={options}
      className="ChartCard"
      style={{ ...options.style }}
    >
      <Skeleton
        loading={state.data === undefined}
        className={`skeleton ${
          state.data === undefined ? null : "deactivated"
        }`}
      >
        {state.data === undefined ? <Empty /> : renderContent()}
      </Skeleton>
    </Card>
  );
};

// Declare data type for Props
ChartCard.propTypes = {
  content: PropTypes.object,
  state: PropTypes.shape({
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }),
  functions: PropTypes.shape({
    saveAsImage: PropTypes.func,
    getTable: PropTypes.func,
  }),
  options: PropTypes.shape({
    chartOption: PropTypes.object,
    columns: PropTypes.array,
    dataSource: PropTypes.array,
    style: PropTypes.object,
  }),
};

export default ChartCard;
